import React, { useState } from "react";
import "./LoginScreen.css";
import BackButton from "../../components/BackButton/BackButton";
import Button from "../../components/Button/Button";
import Header from "../../components/Header/Header";
import TextInput from "../../components/TextInput/TextInput";
import { emailValidator } from "../../helpers/emailValidator";
import { passwordValidator } from "../../helpers/passwordValidator";
/** Firebase Imports **/
import { auth, signInWithEmailAndPassword } from "../../firebaseConfig";
import { logIn, useDispatch } from "../../features/userSlice";
import { showError } from "../../helpers/showError";
/** **/

const LoginScreen = () => {
	const dispatch = useDispatch();

	const [email, setEmail] = useState({ value: "", error: "" });
	const [password, setPassword] = useState({ value: "", error: "" });
	const [isProcessing, setIsProcessing] = useState(false);

	/**
	 * Main Functions
	 */
	const handleLogin = () => {
		const emailError = emailValidator(email.value);
		const passwordError = passwordValidator(password.value);
		if (emailError || passwordError) {
			setEmail({ ...email, error: emailError });
			setPassword({ ...password, error: passwordError });
			return;
		}

		setIsProcessing(true);
		signInWithEmailAndPassword(auth, email.value, password.value)
			.then((userCredential) => {
				dispatch(
					logIn({
						uid: userCredential.user.uid,
						email: userCredential.user.email,
						name: userCredential.user.displayName,
						role: "user",
					})
				);
				setIsProcessing(false);
				// alert("Successful Login");
				// navigate("/landing");
			})
			.catch((error) => {
				setIsProcessing(false);
				showError(error);
			});
	};
	/** **/

	return (
		<div className="h-full w-full m-0 px-3 py-8 flex flex-col items-center">
			<BackButton target={"/"} className="mr-auto" />
			<Header className={"my-8 mr-auto"} size={"large"}>
				Log In
			</Header>
			<TextInput
				className={"my-2 shadow-none"}
				type={"text"}
				name={"email"}
				id={"email"}
				placeholder={"Email"}
				value={email.value}
				onChange={(e) => {
					setEmail({ value: e.target.value, error: "" });
				}}
				error={email.error !== ""}
				errorMessage={email.error}
			/>
			<TextInput
				className={"my-2 shadow-none"}
				type={"password"}
				name={"password"}
				id={"password"}
				placeholder={"Password"}
				value={password.value}
				onChange={(e) => {
					setPassword({ value: e.target.value, error: "" });
				}}
				error={password.error !== ""}
				errorMessage={password.error}
			/>
			<Button
				className={"my-2"}
				title={isProcessing ? "ooo" : "LOG IN"}
				disabled={isProcessing}
				mode={"filled"}
				size={"full"}
				onClick={(e) => handleLogin()}
			/>
		</div>
	);
};

export default LoginScreen;
